import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 3.08296V2H13V3.08296C15.8377 3.55904 18 6.027 18 9C20.7614 9 23 11.2386 23 14V22H13V15H11V22H1V14C1 11.2386 3.23858 9 6 9C6 6.027 8.16229 3.55904 11 3.08296ZM21 14C21 12.3431 19.6569 11 18 11V20H21V14ZM3 20H6V11C4.34315 11 3 12.3431 3 14V20Z"}}]};

const Castle2Filled = Vue.extend<IconProps>({
  name: 'Castle2FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'castle-2-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Castle2Filled;
